/**
 * Combines filter clauses that must be all fullfilled
 * @param {Array.<string>} clauses    filter clauses array
 * @returns {string}
 */
export const combineAnd = (...clauses) => {
  return clauses
    .filter(clause => clause)
    .join(',')
}
